
import TextInput from "./TextInput"
import DropDown from "./DropDown"
import Checkbox from "./Checkbox"
import TextArea  from "./TextArea"

const DetailsEditor = ({heading, entity, fields}) => {

    const getWidget = (entity, fld) => {
        switch(fld.widget) {
            case "text":
                return (<TextInput entity={entity} fld={fld}/>)
            case "select":
                return (<DropDown entity={entity} fld={fld} />)
            case "checkbox":
                return (<Checkbox entity={entity} fld={fld} />)
            case "textArea":
                return (<TextArea entity={entity} fld={fld} />)
            default:
                return (entity[fld.name])
        }
    }

    return (
        <div className="details-editor">
            {!!heading && <h3>{heading}</h3>}
            <table>
                <colgroup>
                    <col span="1" style={{width: "15%"}} />
                    <col span="1" style={{width: "85%"}} />
                </colgroup>
                <tbody>
                    {fields.map(fld =>
                        <tr key={fld.name}>
                            <td style={{
                                fontWeight: "bold",
                                paddingRight: "10px",
                                textAlign: "right"
                            }}>{fld.label}</td>
                            <td>
                                {getWidget(entity, fld)}
                            </td>
                        </tr>
                    )}
                </tbody>
            </table>
        </div>
    )
}

export default DetailsEditor